import BaseIcon from "@/components/BaseIcon/index.vue";
import Vue from "vue";

Vue.component("base-icon", BaseIcon);
